export const getCrsFromId = (/* id: any */): string => {
  return "synxis";
};
